import { Theme } from "@mui/material/styles";

export enum ItemType {
    Organization,
    User,
}

export const typography = (theme: Theme, ownerState?: { fontSize?: string | number; fontWeight?: string | number }) => {
    const fontSize = ownerState?.fontSize || "0.7rem";
    const fontWeight = ownerState?.fontWeight;
    return {
        display: "-webkit-box",
        overflow: "hidden",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 2,

        ...(fontSize && { fontSize: fontSize }),
        ...(fontWeight && { fontWeight: fontWeight }),
    };
};

export const itemBox = (theme: Theme, ownerState: { type: ItemType; isSelected: boolean }) => {
    const { palette, functions } = theme;
    const { isSelected, type } = ownerState;
    const { rgba } = functions;

    const selectedStyles = () => ({
        borderColor: palette.info.main,
        backgroundColor: rgba(palette.info.main, 0.1),
        "& .MuiTypography-root": {
            color: palette.info.main,
        },
        "&:hover": {
            backgroundColor: rgba(palette.info.main, 0.35),
        },
    });

    const defaultStyles = () => ({
        display: "flex",
        alignItems: "center",
        position: "relative",
        border: "1px solid #f3f3f3",
        borderRadius: 2,
        cursor: "pointer",
        backgroundColor: rgba("#f3f3f3", 0.5),
        px: 1,
        "& p": {
            fontSize: "0.7rem",
        },
        "&:hover": {
            backgroundColor: rgba("#f3f3f3", 1),
        },
    });

    const baseOnType = () => {
        if (type === ItemType.Organization) {
            return {
                justifyContent: "center",
                flexDirection: "column",
                py: 2.5,
                textAlign: "center",
            };
        }
        return {
            justifyContent: "space-between",
            flexDirection: "row",
            py: 1,
            textAlign: "left",
        };
    };

    return {
        ...defaultStyles(),
        ...baseOnType(),
        ...(isSelected && selectedStyles()),
    };
};

export const avatarAndName = () => ({
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    width: "90%",
});
